import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import BestFindsPage from "@/pages/best/page";
import ShoesGuidePage from "@/pages/shoes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/best-superbuy-spreadsheet",
    element: <BestFindsPage />,
  },
  {
    path: "/superbuy-spreadsheet-shoes",
    element: <ShoesGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;